"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerPhoto = void 0;
const ImageViewer_1 = __importDefault(require("@opsbase/web-image/ImageViewer"));
const react_1 = __importStar(require("react"));
function AnswerPhoto(props) {
    var _a, _b;
    const { form, questionNodeId } = props;
    const answer = form.answers[questionNodeId];
    const imageFileNames = ((_a = answer === null || answer === void 0 ? void 0 : answer.photos) === null || _a === void 0 ? void 0 : _a.length)
        ? answer.photos.split(',')
        : ((_b = answer === null || answer === void 0 ? void 0 : answer.value) === null || _b === void 0 ? void 0 : _b.length)
            ? answer.value.split(',')
            : [];
    return (0, react_1.useMemo)(() => react_1.default.createElement(ImageViewer_1.default, { fileNames: imageFileNames, size: 100 }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    imageFileNames);
}
exports.AnswerPhoto = AnswerPhoto;
exports.default = AnswerPhoto;
